import { render, staticRenderFns } from "./UpdateAGroupClass.vue?vue&type=template&id=525df7be"
import script from "./UpdateAGroupClass.vue?vue&type=script&lang=js"
export * from "./UpdateAGroupClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports